define('core/ModernizrExtensions',[
	'Modernizr',
	'global!navigator',
], function (
	Modernizr,
	navigator
) {
	'use strict';

	// Browser detection (http://stackoverflow.com/a/9851769)
	// https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#Browser_Name

	// Opera 8.0+ (UA detection to detect Blink/v8-powered Opera)
	var isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
	// Firefox 1.0+
	var isFirefox = typeof InstallTrigger !== 'undefined';
	// Chrome 1+
	var isChrome = !!window.chrome && !isOpera;
	// At least Safari 3+: "[object HTMLElementConstructor]"
	var isSafari = (Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0) || (navigator.userAgent.match(/Safari/) && !isChrome);
	// At least IE6
	var isIE = (function() {
		// p2 media - MN: added extra closure to ensure the special MSIE directive
		// https://msdn.microsoft.com/de-de/library/8ka90k2e(v=vs.94).aspx

		/*@cc_on!@*/
		return false || !!document.documentMode;
	})();
	var isEdge = /Edge/.test(navigator.userAgent);

	Modernizr.addTest('browser', window !== undefined);
	Modernizr.addTest('browser.opera', isOpera);
	Modernizr.addTest('browser.firefox', isFirefox);
	Modernizr.addTest('browser.safari', isSafari);
	Modernizr.addTest('browser.chrome', isChrome);
	Modernizr.addTest('browser.ie', isIE);
	Modernizr.addTest('browser.edge', isEdge);

	// p2 media - MN
	var platform = navigator.platform || navigator.userAgent;
	var isWin = /Win/i.test(platform);
	var isMac = /Mac/i.test(platform);
	var isIos = /iP(hone|ad|od)/i.test(platform);
	var isAndroid = /Android/i.test(navigator.userAgent);
	var isLinux = /Linux/i.test(platform);

	Modernizr.addTest('platform', platform !== undefined);
	Modernizr.addTest('platform.win', isWin);
	Modernizr.addTest('platform.mac', isMac);
	Modernizr.addTest('platform.ios', isIos);
	Modernizr.addTest('platform.android', isAndroid);
	Modernizr.addTest('platform.linux', isLinux);


	// @TODO: check if this is really needed!
	// http://jsfiddle.net/westonruter/eAVp2/
	Modernizr.addTest('before_after', function() {

		var head = document.getElementsByTagName('head')[0];
		var style = document.createElement('style');
		style.type = 'text/css';
		var rules = [
			'#modernizr-before,#modernizr-after {visibility:hidden; position:absolute;}',
			'#modernizr-before:before {content: "(-:";}',
			'#modernizr-after:after {content: ":-)";}'
		].join('');

		// thanks http://stackoverflow.com/questions/524696/how-to-create-a-style-tag-with-javascript
		if(style.styleSheet){
			style.styleSheet.cssText = rules;
		}
		else {
			style.appendChild(document.createTextNode(rules));
		}

		head.appendChild(style);

		var beforeDiv = document.createElement('div');
		beforeDiv.id = "modernizr-before";
		document.body.appendChild(beforeDiv);

		var afterDiv = document.createElement('div');
		afterDiv.id = "modernizr-after";
		document.body.appendChild(afterDiv);

		var hasBefore = beforeDiv.offsetWidth > 0;
		var hasAfter = afterDiv.offsetWidth > 0;

		// Clean up
		style.parentNode.removeChild(style);
		afterDiv.parentNode.removeChild(afterDiv);
		beforeDiv.parentNode.removeChild(beforeDiv);

		return hasBefore && hasAfter;
	});
});

